import React from 'react';
import { useTranslation } from 'next-i18next';
import { StoreWithDistance } from '@context/StoresContext';
import Modal from '@components/global/Modal';
import { useUI } from '@context/GlobalUIContext';
import StoreCard from '@components/stores/StoreCard';
import AlertInlineMessage from '@components/ui/AlertInlineMessage';
import { useStoresUI } from '@context/StoresContext';
import { usePdp } from '@context/PdpContext';
import FixedHeader from './FixedHeader';

import styles from './StockLevelModal.module.scss';

export const StockLevelModal = () => {
  const { displayStockLevelModal, closeStockLevelModal, stockModalFilter } =
    useUI();
  const { t } = useTranslation('pdp');
  const { stores, favouriteStoreDetails } = useStoresUI();
  const { selectedVariant } = usePdp();

  const headingId = 'store-level-modal-heading';
  return (
    <Modal
      labelledBy={headingId}
      onClose={closeStockLevelModal}
      isOpen={displayStockLevelModal}
      classNames={styles.modal}
      fixedInHeader={<FixedHeader headingId={headingId} />}
    >
      <div className={styles.storeWrapper}>
        <AlertInlineMessage
          messageType="INFORMATION"
          classNames={styles.stockDetails}
        >
          <span>
            {!favouriteStoreDetails?.data?.mec_store_id && selectedVariant
              ? t('product.stock.message')
              : t('product.stock.message.noStoreSelected')}
          </span>
        </AlertInlineMessage>
        {stores?.map((store: StoreWithDistance) => (
          <StoreCard
            storesData={store}
            isModal
            key={store.data.mec_store_id}
            isPdp
            filter={stockModalFilter}
          />
        ))}
      </div>
    </Modal>
  );
};

export default StockLevelModal;
